import {
  securePostRequest,
  cancelableSecurePostRequest,
  secureRequest,
  deleteRequest,
  securePostBlobDownloadRequest,
} from 'utils/request';

export interface ITableRequest {
  schema?: string;
  table: string;
  fields?: string[];
  limit?: number;
  offset?: number;
  filters?: string | { [x: string]: any[]; }[];
  distinct?: boolean;
  customsql?: string;
  sort?: {
    field: string;
    direction: string;
  };
  apiType: number;
  type?: string;
  source?: string;
}

export interface IDeleteRequest extends ITableRequest {
  field: string;
  indexes: string;
  title: string;
  rows: any[];
}

export const getList = (params: ITableRequest) => {
  return securePostRequest(
    `/api/table/list`,
    ['handbooks/table']
  )(params);
};

export const deleteList = async (params: IDeleteRequest): Promise<any> => {
  return securePostRequest(
    `/api/table/list/delete`,
    ['handbooks/table']
  )(params);
};

export const deleteListRA = async (config: any, rows: any): Promise<any> => {
  return securePostRequest(
    `/api/table/list/deleteRA`,
    ['handbooks/table']
  )({ config, rows });
};

export const saveElement = async (config: any, row: any): Promise<any> => {
  return securePostRequest(
    `/api/table/element/save`,
    ['handbooks/table']
  )({ config, row });
};

export const getFilterList = (params: ITableRequest) => {
  return cancelableSecurePostRequest(
    `/api/table/list`,
    'handbooks/table'
  )(params);
};

export const getTripStops = (trip_id: number) => {
  return secureRequest( `/api/table/tripstops?trip_id=${trip_id}`);
}

export const updateTripStops = (stops: { id: number; distance: number }[]) => {
  return securePostRequest(
    `/api/table/tripstops`,
    ['handbooks/table']
  )({stops});
}

export const importData = async (config: any, data: any): Promise<any> => {
  let pathName = '';
  if (config.import.insertProcedure) pathName = '/appoint-vehicles-to-route';
  return securePostRequest(
    `/api/table/import${pathName}`,
    ['handbooks/table']
  )({ config, csv: data });
};

export const widgetAddCameraVehicle = async (vehList: string[]) => {
  return securePostRequest(
    `/api/widget/addcamersvehicle`,
    ['handbooks/table']
  )({ veh_list: vehList });

}

export const exportFile = async (data: any) => {
  return securePostBlobDownloadRequest(
    `/api/table/export`,
    ['handbooks/table']
  )(data);
}

export const exportFileNode = async (format: string, data: any) => {
  return securePostBlobDownloadRequest(
    `/reportapi/v1/handbook/${format}`,
    ['handbooks/table'],
    {
      xTimesone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      handleNoResponse: true,
      type: 'json',
      storeToken: true,
    }
  )(data);
}
